import { Link } from "@/router";

export function NotFound() {
   return (
      <div className="flex min-h-dvh flex-col items-center justify-center bg-background px-4 py-12 sm:px-6 lg:px-8">
         <div className="mx-auto max-w-md text-center">
            <div className="mx-auto h-12 w-12 text-primary" />
            <h1 className="mt-4 text-6xl font-bold tracking-tight text-foreground sm:text-7xl">
               404
            </h1>
            <p className="text-muted-foreground mt-4 text-lg">
               Oops, it looks like the page you're looking for doesn't exist.
            </p>
            <div className="mt-6">
               <Link
                  to="/"
                  className="inline-flex items-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-white shadow-sm transition-colors hover:bg-primary/90 focus:ring-2 focus:ring-primary focus:ring-offset-2 focus:outline-none"
                  prefetch="intent"
               >
                  Go to Homepage
               </Link>
            </div>
         </div>
      </div>
   );
}

export default NotFound;
